const defaultColor: SlugColorType = 'gray';

export const getContactStateColor = (
  status?: LatestContactState
): SlugColorType => {
  if (!status) return defaultColor;

  switch (status) {
    case 'active':
      return 'main';
    case 'READY_FOR_OUTREACH':
    case 'AI_READY_TO_START':
      return 'warning';
    case 'goal_reached':
      return 'success';
    case 'OUTREACH_FAILED':
    case 'AI_FAILED':
      return 'danger';
    default:
      return defaultColor;
  }
};
